/* Auto-generated by scripts/generate-version.js — do not edit by hand. */
import { AppVersionInfo } from '../interfaces/app-version.interface';

/** Fingerprint of the JS bundle currently running in the browser. */
export const APP_VERSION: AppVersionInfo = {
  "version": "6166-69e45c0da95769f81d8c48eb977d143837ecad67",
  "buildTime": "2026-10-19T12:32:25.571Z"
};
